const API_URL = process.env.REACT_APP_API_URL ||'https://tvbe-api.intertech.de/api/v1';
export const DIGITAL_ASSET_URL = `${API_URL}/digital_assets`;
//export const DIGITAL_ASSET_DIRECT_UPLOAD_URL = `https://tvbe-api.intertech.de/api/rails/active_storage/direct_uploads`;
export const DIGITAL_ASSET_DIRECT_UPLOAD_URL = `${API_URL}/active_storage/direct_uploads`;
export const USER_LOGIN_URL = `${API_URL}/authenticate`;
export const PRODUCT_LIST_URL = `${API_URL}/products`;
export const PRODUCT_URL = `${API_URL}/products`;
export const RISK_BEARER_URL = `${API_URL}/risk_bearers`;
